import styled from "@emotion/styled";

export const DocumentationWrapper = styled.div`
  display: flex;
  gap: 32px;
  flex-direction: column;
`;
